import { takeEvery, put, call } from "redux-saga/effects"
import toastr from "toastr"

// Quote Redux States
import {
    GET_QUOTES,
    GET_QUOTE_DETAIL,
    ADD_NEW_QUOTE,
    UPDATE_QUOTE,
    DELETE_QUOTE,
    CONVERT_QUOTE_TO_INVOICE,
} from "./actionTypes"

import {
    getQuotesSuccess,
    getQuotesFail,
    getQuoteDetailSuccess,
    getQuoteDetailFail,
    addNewQuoteSuccess,
    addNewQuoteFail,
    updateQuoteSuccess,
    updateQuoteFail,
    deleteQuoteSuccess,
    deleteQuoteFail,
    convertQuoteToInvoiceSuccess,
    convertQuoteToInvoiceFail,
} from "./actions"

// Include helper
import {
    getQuotes,
    getQuoteDetail,
    addNewQuote,
    updateQuote,
    deleteQuote,
    convertQuoteToInvoice,
} from "../../helpers/fakebackend_helper"

function* fetchQuotes({ payload: params }) {
    try {
        const response = yield call(getQuotes, params)
        yield put(getQuotesSuccess(response))
    } catch (error) {
        yield put(getQuotesFail(error))
    }
}

function* fetchQuoteDetail({ payload: id }) {
    try {
        const response = yield call(getQuoteDetail, id)
        yield put(getQuoteDetailSuccess(response))
    } catch (error) {
        yield put(getQuoteDetailFail(error))
    }
}

function* onAddNewQuote({ payload: { quote, history } }) {
    try {
        const response = yield call(addNewQuote, quote)
        yield put(addNewQuoteSuccess(response))
        toastr.success("Devis créé avec succès")
        if (history) {
            if (typeof history === 'function') {
                history("/finance/quotes")
            } else {
                history.push("/finance/quotes")
            }
        }
    } catch (error) {
        yield put(addNewQuoteFail(error))
        toastr.error("Erreur lors de la création du devis")
    }
}

function* onUpdateQuote({ payload: { quote, history } }) {
    try {
        const response = yield call(updateQuote, quote)
        yield put(updateQuoteSuccess(response))
        toastr.success("Devis mis à jour avec succès")
        if (history) {
            if (typeof history === 'function') {
                history("/finance/quotes")
            } else {
                history.push("/finance/quotes")
            }
        }
    } catch (error) {
        yield put(updateQuoteFail(error))
        toastr.error("Erreur lors de la mise à jour du devis")
    }
}

function* onDeleteQuote({ payload: id }) {
    try {
        const response = yield call(deleteQuote, id)
        yield put(deleteQuoteSuccess(response))
    } catch (error) {
        yield put(deleteQuoteFail(error))
    }
}

function* onConvertQuote({ payload: { id, history } }) {
    try {
        const response = yield call(convertQuoteToInvoice, id)
        yield put(convertQuoteToInvoiceSuccess(response))
        toastr.success("Devis converti en facture avec succès")
        if (history) {
            const redirectPath = `/finance/invoices/${response.id}`
            if (typeof history === 'function') {
                history(redirectPath)
            } else {
                history.push(redirectPath)
            }
        }
    } catch (error) {
        yield put(convertQuoteToInvoiceFail(error))
        toastr.error("Erreur lors de la conversion du devis")
    }
}

function* quoteSaga() {
    yield takeEvery(GET_QUOTES, fetchQuotes)
    yield takeEvery(GET_QUOTE_DETAIL, fetchQuoteDetail)
    yield takeEvery(ADD_NEW_QUOTE, onAddNewQuote)
    yield takeEvery(UPDATE_QUOTE, onUpdateQuote)
    yield takeEvery(DELETE_QUOTE, onDeleteQuote)
    yield takeEvery(CONVERT_QUOTE_TO_INVOICE, onConvertQuote)
}

export default quoteSaga
